//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Hexagon from "@/components/objects/public/shared-blocks/Hexagon.vue";
import IconView from "@/components/objects/IconView.vue";
import { intToHumanReadable } from "@/utils/converter.js";
import { datesToHuman } from "@/utils/dates.js";
import typo from "ru-typo";
import debounce from "lodash/debounce.js"
import { v4 as uuidv4 } from 'uuid';
import { colorToTransparantize, adjustColorBrightness } from "@/utils/helpers.js";
import { DesignExtra } from "@/utils/dto/objects.js";
import factsEntranceAnimation from "@/mixins/factsEntranceAnimation.js";

export default {
  name: "Default",
  components: { IconView, Hexagon },
  mixins: [factsEntranceAnimation],
  inject: {
    specialProject: {
      default: false
    }
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      required: false,
      default: () => ''
    },
    objectLabel: {
      type: String,
      required: false,
      default: () => {}
    },
    design: {
      type: String,
    },
    design_extra: {
      type: [Object, DesignExtra],
      default: () => {}
    },
    template: {
      type: Object,
    },
    theme: {
      type: String,
    },
    listInfo: {
      type: Object
    },
    user: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      labelColor: '#7895CB',
      colors: [
        '#9681EB',
        '#4FC0D0',
        '#19A7CE',
        '#00B4D8',
        '#41AAA8',
        '#5B7DB1',
        '#1597E5',
      ],
      isSmall: undefined,
      domId: ''
    }
  },
  computed: {
    siTypes() {
      return (this.$store.state.property_templates.consts.si ?? [])
    },
    coloredItems() {
      if (this.isSmall === undefined) return []
      let insertIndex = 0

      const items = this.items.map((fact, index) => {
        const item = JSON.parse(JSON.stringify(fact))
        item.id = `${fact.id}_${index}`
        item.color = this.getBgColor(index + 1)

        if (this.getBgGradientEnabled && item.color) {
          item.gradient = `linear-gradient(to ${this.getBgGradientDirection}, ${this.getBgGradientShadowDirection === 'transparent' ? `${item.color}, transparent` : `${item.color}, ${adjustColorBrightness((item.color), 1.20)}`})`
        }

        item.humanReadableValue = this.buildHumanReadable(fact.value)
        item.descriptionFontSize = `${this.computeDescrFontSize(fact.description)}px`
        item.description = typo(fact.description, { hyphens: true })
        return item
      })

      if (this.isSmall) {
        if (items.length > 3 && items.length % 3 !== 1) {
          insertIndex = 2
        }
      } else {
        if ([4, 5].includes(items.length)) {
          insertIndex = 1
        } else if (items.length > 5) {
          insertIndex = 3
        }

      }

      items.splice(insertIndex, 0, {
        id: uuidv4(),
        humanReadableValue: {
          val: [this.label]
        },
        color: this.getFirstBlockBgColor,
        gradient: this.getFirstBlockBg,
        value: {
          type: 'label'
        }
      })

      return items
    },
    wrapperClassList() {
      const itemsLength = this.coloredItems.length

      return {
        'two': itemsLength === 2,
        'three': itemsLength === 3,
        'four': itemsLength === 4,
        'six': itemsLength === 6,
        'eight': itemsLength >= 8 && itemsLength % 5 === 3,
        'four-six': 3 < itemsLength && itemsLength < 7,
        'many': itemsLength > 6,
        'small-center': itemsLength === 3 || itemsLength % 3 === 1
      }
    },
    paletteList() {
      return this.$store.state["property_templates"]["consts"].palette;
    },
    bgPalette() {
      if (this.design_extra?.bg?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.bg.palette)[0];
      }

      return null;
    },
    getTextColor() {
      return this.design_extra?.text?.color ?? null;
    },
    getMask() {
      return this.design_extra?.mask?.name ?? null;
    },
    getFirstBlockBg() {
      if (this.getFirstBlockBgGradientEnabled) {
        return `linear-gradient(to ${this.getFirstBlockBgGradientDirection}, ${this.getFirstBlockBgGradientShadowDirection === 'transparent' ? `${this.getFirstBlockBgColor}, transparent` : `${this.getFirstBlockBgColor}, ${adjustColorBrightness(this.getFirstBlockBgColor, 1.20)}`})`
      }
      return this.getFirstBlockBgColor ?? null;
    },
    getFirstBlockBgColor() {
      if (this.design_extra?.first_block?.bg_color) {
        return this.design_extra?.first_block?.bg_color
      } else {
        if (this.bgPalette) {
          return this.bgPalette.main_color;
        } else if (this.design_extra?.bg?.color) {
          return this.design_extra.bg.color;
        }
      }

      return null;
    },
    getFirstBlockBgGradientEnabled() {
      if (this.hasNotFirstBlockBgAndHasBgPalette) {
        return this.design_extra?.bg?.gradient_enabled ?? null;
      } else {
        return this.design_extra?.first_block?.gradient_enabled ?? null;
      }
    },
    getFirstBlockBgGradientDirection() {
      if (this.hasNotFirstBlockBgAndHasBgPalette) {
        return this.design_extra?.bg?.gradient_direction ?? null;
      } else {
        return this.design_extra?.first_block?.gradient_direction ?? null;
      }
    },
    getFirstBlockBgGradientShadowDirection() {
      if (this.hasNotFirstBlockBgAndHasBgPalette) {
        return this.design_extra?.bg?.gradient_shadow_direction ?? null;
      } else {
        return this.design_extra?.first_block?.gradient_shadow_direction ?? null;
      }
    },
    getFirstBlockTitleColor() {
      return this.design_extra?.first_block?.title_color ?? '#ffffff' ?? null;
    },
    getBgGradientEnabled() {
      return this.design_extra?.bg?.gradient_enabled ?? null;
    },
    getBgGradientDirection() {
      return this.design_extra?.bg?.gradient_direction ?? null;
    },
    getBgGradientShadowDirection() {
      return this.design_extra?.bg?.gradient_shadow_direction ?? null;
    },
    hasNotFirstBlockBgAndHasBgPalette() {
      if (!this.design_extra?.first_block?.bg_color && this.bgPalette) {
        return true;
      } else return false;
    },
    getIconColor() {
      return this.design_extra?.icon_color?.color ?? 'white';
    },
  },
  mounted() {
    this.checkIsSmall()
    this.domId = `facts-${this.listInfo.id}`
    window.addEventListener('resize', this.resizeHandler, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler, { passive: true })
  },
  methods: {
    getDate([from, to]) {
      if (!from && !to) {
        return ''
      }
      if (!to) {
        return `${from[0] || ''} ${from[1] || ''}`
      } else {
        return `${from[0] || ''} ${from[1] || ''} - ${to[0] || ''} ${to[1] || ''}`
      }
    },
    getBgColor(index) {
      if (this.bgPalette) {
        return colorToTransparantize([this.bgPalette.main_color, ...this.bgPalette.colors][index % [this.bgPalette.main_color, ...this.bgPalette.colors].length], 0.65);
      } else if (this.design_extra?.bg?.color) {
        return colorToTransparantize(this.design_extra.bg.color, 0.65);
      }

      return null;
    },
    buildHumanReadable(value) {
      switch (value.type) {
      case "number":
        const si = value.si ? this.siTypes.find(x => x.id === value.si) : null

        return {
          val: [intToHumanReadable(value.data), si ? si : null],
          style: {}
        }
      case "date":
        return {
          val: datesToHuman({ value: value.data.vfrom?.value || value.data.vfrom }, { value: value.data.vto?.value || value.data.vto }, 'object'),
          style: {}
        }
      default:
        return {
          val: [value.data],
          style: {
            'font-size': `${this.computeValFontSize(value.data)}px`
          }
        }
      }
    },
    computeDescrFontSize(descr = "") {
      const length = descr.length;

      if (length <= 80) return 15
      else if (length < 90) return 14
      else if (length < 100) return 13
      else if (length < 120) return 12
      else if (length < 150) return 11
      return 10
    },
    computeValFontSize(descr = "") {
      const length = descr.length;

      if (length <= 25) return 16
      else if (length < 35) return 14
      return 13
    },
    checkIsSmall() {
      this.isSmall = this.$refs.factsContainer.clientWidth <= 500
    },
    resizeHandler: debounce(function () {
      this.checkIsSmall()
    }, 150)
  }
}
